export enum StorageEnum {
    VENTAS_MOSTRADOR = 'VM',
    PEDIDOS_PIEZAS = 'PZ',
    FACT_GESTIONCOBROS = 'FGC',
    GESTION_VO = "GVO",
    GESTION_OR = "GOR",
    RESERVA_VC = 'RVC',
    AGENDA = 'RVC',
    PRESUPUESTOS_TALLER = 'PT',
    FACTURACION_OR = 'FO',
    REDIRECT_GESTION_VEHICULOS = 'REDIRECT_GESTION_VEHICULOS',
    GESTION_TERCEROS = "GT",
    GESTION_VEHICULOS = "GV",
    BACK = "RETURN_URL"
}
